/**
 * Route for `affiliate-groups`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AffiliateGroupsPage } from "../features/affiliate-groups/AffiliateGroupsPage";

export const affiliateGroupsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/affiliate-groups",
	component: AffiliateGroupsPage,
});

export default affiliateGroupsRoute;
